export enum LegalLink {
  AGB = 'AGB',
  Datenschutz = 'Datenschutz',
  Impressum = 'Impressum',
  Sitemap = 'Sitemap',
}

export type LegalLinkRecord = Record<
  LegalLink,
  {
    text: string;
    url: string;
  }
>;
